import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .actions-wrapper {
    width: 100%;
    margin-left: 32px;
    display: flex;
    gap: 32px;

    .border-line {
      content: '';
      height: 44px;
      border-right: 1px solid ${(props) => props.theme.colors.outline};
    }
  }

  .map-wrapper {
    width: 403px;
  }

  .map-container {
    width: 403px;
    height: 100%;
  }

  .widgets-container {
    display: flex;
    background-color: ${(props) => props.theme.colors.widget_background};
    border-radius: 12px;
    overflow: hidden;
  }

  .sub-header {
    display: flex;
    justify-content: space-between;
  }
`;

export default { Wrapper };
